export function spinner(ctx) {
    return {
        styles: {
            main:      { bg_color: ctx.SURFACE, bg_opa: 0, border_width: 0, border_color: 'black', radius: 0, line_color: '#e0e0e0', line_width: 15 },
            indicator: { line_color: ctx.accent, line_rounded: true },
        },
    };
}
